import { forwardRef } from "react";

interface MfeIframeLoaderProps {
  src: string;
  title: string;
  onLoad?: () => void;
}

const MfeIframeLoader = forwardRef<HTMLIFrameElement, MfeIframeLoaderProps>(
  ({ src, title, onLoad, ...rest }, ref) => {
    return (
      <iframe
        ref={ref}
        src={src}
        title={title}
        onLoad={onLoad}
        style={{
          width: "100%",
          border: "none",
          height: "100%",
        }}
        // Consider sandbox attributes for security
        // sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
        {...rest}
      />
    );
  }
);

MfeIframeLoader.displayName = "MfeIframeLoader";
export default MfeIframeLoader;
